import RSAA from '../../../node_modules/redux-api-middleware/lib/RSAA';
import { getCaseID, getHeaders, getPayload } from '../../utils';
import { METHOD_GET, METHOD_POST } from '../../utils/constants';
import { technicalErrorPage, submitEvidenceCall } from '../../store/dataCapture';
import { caseType } from '../offers';
import { generateMicroenterprisePayload } from './payloads';
import { STATUS_409 } from '../../utils/errorCodes';

export const REQUEST_COMPLETED = 'REQUEST_COMPLETED';
export const COMPLETED_SUCCESS = 'COMPLETED_SUCCESS';
export const COMPLETED_FAIL = 'COMPLETED_FAIL';

export const SUBMIT_ENTERPRISE_FORM = 'SUBMIT_ENTERPRISE_FORM';
export const SUBMIT_ENTERPRISE_FORM_SUCCESS = 'SUBMIT_ENTERPRISE_FORM_SUCCESS';
export const SUBMIT_ENTERPRISE_FORM_FAIL = 'SUBMIT_ENTERPRISE_FORM_FAIL';
export const FROM_CAS_FLOW = 'from_cas_flow';

export const requestCompletedTask = () => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/cases/bsap/${caseType()}/${getCaseID()}/tasks/completed`,
    method: METHOD_GET,
    headers: getHeaders(),
    types: [
      {
        type: REQUEST_COMPLETED,
        meta: { loading: true }
      },
      {
        type: COMPLETED_SUCCESS,
        payload: (action, state, res) => getPayload(action, state, res),
        meta: {
          loading: false
        }
      },
      {
        type: COMPLETED_FAIL,
        meta: () => {
          return { nextAction: technicalErrorPage(), loading: false };
        }
      }
    ]
  }
});

export const submitMicroenterprise = (isSoleTrader, switchDate) => ({
  [RSAA]: {
    endpoint: getRequestUrl(isSoleTrader),
    method: METHOD_POST,
    headers: { 'x-bpi-version': '1.2.0' },
    body: state => generateMicroenterprisePayload(state, isSoleTrader, switchDate),
    types: [
      {
        type: SUBMIT_ENTERPRISE_FORM,
        meta: { loading: true }
      },
      {
        type: SUBMIT_ENTERPRISE_FORM_SUCCESS,
        payload: (action, state, res) => getPayload(action, state, res),
        meta: {
          loading: true,
          nextAction: submitEvidenceCall('', caseType(), FROM_CAS_FLOW)
        }
      },
      {
        type: SUBMIT_ENTERPRISE_FORM_FAIL,
        payload: (action, state, res) => getPayload(action, state, res),
        meta: (_action, state, res) => processsSwitchServiceError(state, res)
      }
    ]
  }
});

const getRequestUrl = isSoleTrader => {
  const baseUrl = ':api_paas_url/banks/:bank_id/cases/cas';
  if (isSoleTrader) {
    return `${baseUrl}/sole`;
  }
  return `${baseUrl}/microenterprise`;
};

const processsSwitchServiceError = (state, res) => {
  if (res.status === STATUS_409) {
    return {
      content: state.content,
      loading: false,
      errorCode: res.json && res.json.error ? res.json.error.code : ''
    };
  }
  return { nextAction: technicalErrorPage(), loading: false };
};
